<template>
  <div class="pa-2">
    <custom-tabs v-model="tabs" :tab-items="[{text: 'ارتقا'}, {text: 'پله'}]" grow>
      <!--    <custom-tabs v-model="tabs" :tab-items="[{text: 'ارتقا'}]" grow>-->
      <template v-slot:staticItems>
        <v-tab-item>
          <div v-if="!loading" class="px-4">
            <v-radio-group v-model="selectedUpgrades">
              <template v-for="(item, i) in upgradeList">
                <template v-for="(radio, j) in item.sub">
                  <v-radio :key="j" :label="radio.title" :value="radio.slug"
                           @click="computedCode = {...item.sub[radio.slug]}"/>

                  <small class="text-right mb-4 d-block grey--text">{{ radio.description }}</small>
                </template>

                <v-divider class="mt-0"/>
              </template>
            </v-radio-group>
          </div>

          <div v-else class="text-center pa-4">
            <v-progress-circular class="mx-auto" color="primary" indeterminate size="40" width="5"/>
            <br>
            <br>
            درحال دریافت اطلاعات...
          </div>
        </v-tab-item>

        <v-tab-item>
          <v-radio-group v-if="!!pelleList.length && !loading" v-model="selectedPelle">
            <v-radio v-for="(item, i) in pelleList" :key="i" :label="item.title" :value="item.key"
                     @click="computedStep = {...item}"/>
          </v-radio-group>

          <div v-else class="text-center pa-4">
            <v-progress-circular class="mx-auto" color="primary" indeterminate size="40" width="5"/>
            <br>
            <br>
            درحال دریافت اطلاعات...
          </div>
        </v-tab-item>
      </template>
    </custom-tabs>
  </div>
</template>

<script>
import {Axios2} from "@/main";

export default {
  name: "autoPayDialog",

  props: {
    code: Object,
    step: Object,
    token: String
  },

  data() {
    return {
      tabs: 0,
      radios: [['reorder'], ['urgent', 'urgent-reorder'], ['submit'], ['renew-reorder', 'renew']],
      loading: false,
      selectedUpgrades: '',
      selectedPelle: '',
      upgradeList: [],
      pelleList: []
    }
  },

  mounted() {
    this.fetch()
  },

  computed: {
    computedCode: {
      get() {
        return this.code
      },
      set(val) {
        this.$emit('update:code', val)
      }
    },
    computedStep: {
      get() {
        return this.step
      },
      set(val) {
        this.$emit('update:step', val)
      }
    }
  },

  watch: {
    tabs(val) {
      !!val && this.fetchPelle()
    }
  },

  methods: {
    fetch() {
      this.loading = true

      Axios2.get(`divar/advertise/costs/${this.token}`)
        .then(({data}) => {
          try {
            this.upgradeList = this.radios.reduce((arr, curr) => {
              let obj = {
                value: null,
                sub: {}
              }
              data.data.forEach(item => {
                if (curr.includes(item.slug))
                  obj.sub[item.slug] = item
              })
              arr.push(obj)

              return arr
            }, [])
          } catch (e) {
            console.log(e)
          }
        })
        .catch(({response}) => {
          this.$toast.error('خطا در دریافت لیست ارتقا')
          console.log('failed to get upgrade list: ', response)
        })
        .finally(() => this.loading = false)
    },
    fetchPelle() {
      this.loading = true

      Axios2.get(`divar/pelle/${this.token}`)
        .then(({data}) => this.pelleList = data.data)
        .catch(({response}) => console.log('failed to get pelle items: ', response))
        .finally(() => this.loading = false)
    }
  }
}
</script>

<style scoped>

</style>